import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {MetricUsersResponse} from '../responses';

@Injectable({
  providedIn: 'root'
})
export class TorchMetricsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  getRecentlyLoggedInUsers() {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/metrics')
      .addSegment('/recentUsers')
      .get;

    return this.httpClient.get<MetricUsersResponse>(endpointURL);
  }
}

